var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-navigation-button',{staticClass:"cz2__main-navigation-button",attrs:{"group":_vm.currentGroup,"isOpen":_vm.isNavMenuOpen,"shouldReclaimFocus":_vm.shouldReclaimFocus,"light":_vm.light},nativeOn:{"click":function($event){return _vm.openNavMenu.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }